import overlayController from './overlay-template.controller';
import overlayView from './overlay-template.view.html';
import './reference-overlay.scss';

const overlayComponent = {

  template: overlayView,
  controller: overlayController,
  controllerAs: 'vm'

};

export default overlayComponent;


// WEBPACK FOOTER //
// ./src/components/overlay/overlay-template.component.js